import React from "react";
import { Navigate } from "react-router-dom";
import Login from "./components/Login";
import NewRegistration from "./components/NewRegistration";
import AssignRole from "./components/AssignRole";
import VisitorAnalytics from "./layouts/visitornalytics/VisitorAnalytics";
import Dashboard from "./layouts/dashboard/Dashboard";
import NewForm from "./layouts/visitor/component/NewForm";
import CreateCategoryForm from "./layouts/CreateCategory/CreateCategoryForm";
import VisitorsTable from "./layouts/visitorTable/VisitorsTable";
import VisitorsProblems from "./layouts/visitorProblems/VisitorProblems";
import Broadcast from "./layouts/broadcast/Broadcast";
import PublicForm from "./layouts/publicForm";
import { RoleContext } from "./RoleContext";
import Unauthorized from "./components/Unauthorized";
import VisitorSearch from "./layouts/publicForm/VisitorSearch";
import VisitorDetails from "./layouts/visitorDetails/VisitorDetails";
import OfficeUserManager from "./layouts/OfficeUserManager/OfficeUserManager";

// PrivateElement checks role and token
const PrivateElement = ({ element: Element, roles }) => {
  const { user, token } = React.useContext(RoleContext);

  // if (!token) {
  //   return <Navigate to="/" />;
  // }

  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return <Element />;
};

// Define routes
const routes = [
  {
    path: "/",
    element: <Login />,
    roles: [],
    layout: null, // No layout for login page
  },
  {
    path: "/registration",
    element: <NewRegistration />,
    roles: [],
    layout: null, // No layout for registration page
  },
  {
    path: "/dashboard",
    element: <PrivateElement element={Dashboard} roles={["admin", "staff", "super-admin"]} />,
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/register",
    element: <PrivateElement element={NewForm} roles={["admin", "staff", "super-admin"]} />,
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/office",
    element: <PrivateElement element={OfficeUserManager} roles={["super-admin"]} />,
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/visitors",
    element: (
      <PrivateElement element={VisitorsTable} roles={["admin", "staff", "super-admin"]} />
    ),
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/visitor-problems",
    element: (
      <PrivateElement element={VisitorsProblems} roles={["admin", "staff", "super-admin"]} />
    ),
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/visitornalytics",
    element: (
      <PrivateElement element={VisitorAnalytics} roles={["admin", "staff", "super-admin"]} />
    ),
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/broadcast",
    element: <PrivateElement element={Broadcast} roles={["admin", "staff", "super-admin"]} />,
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/assign-role",
    element: <AssignRole />,
    roles: [],
    layout: null, // No layout for assign-role page
  },
  {
    path: "/createCategory",
    element: (
      <PrivateElement element={CreateCategoryForm} roles={["super-admin"]} />
    ),
    layout: "sidebar", // Sidebar layout
  },
  {
    path: "/visitor-details/:visitor_id", // Use 'visitor_id' instead of 'id'
    element: (
      <PrivateElement element={VisitorDetails} roles={["admin", "staff", "super-admin"]} />
    ),
    layout: "sidebar",
  },

  {
    path: "/visitor-form",
    element: <PublicForm />,
    roles: [],
    layout: null, // No layout for public form page
  },
  {
    path: "/follow-up",
    element: <VisitorSearch />,
    roles: [],
    layout: null, // No layout for public form page
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
    roles: [],
    layout: null, // No layout for unauthorized page
  },
];

export default routes;
